import RouterLinkShim from '../component/RouterLinkShim.vue';

export default function(app){

    app.component('router-link', RouterLinkShim);
}